import { en, nl } from '@formkit/i18n'
import { defineFormKitConfig } from '@formkit/vue'
import type { FormKitNode } from '@formkit/core'

const legends = ['checkbox_multi', 'radio_multi', 'repeater', 'transferlist']

function addAsteriskPlugin(node: FormKitNode) {
  if (['button', 'submit', 'hidden', 'group', 'list', 'meta'].includes(node.props.type)) return

  node.on('created', () => {
    const legendOrLabel = legends.includes(`${node.props.type}${node.props.options ? '_multi' : ''}`) ? 'legend' : 'label'

    if (node.props.definition.schemaMemoKey) {
      node.props.definition.schemaMemoKey += `${node.props.options ? '_multi' : ''}_add_asterisk`
    }

    let currentLocale: string
    try {
      currentLocale = (node.context && (node.context as any).locale) || (node.config as any)?.locale
    } catch {
      currentLocale = 'nl'
    }

    const schemaFn = node.props.definition.schema
    node.props.definition.schema = (
      sectionsSchema = {
        currentLocale,
      },
    ) => {
      sectionsSchema[legendOrLabel] = {
        children: [
          '$label',
          {
            $el: 'span',
            if: '$state.required',
            attrs: {
              class: '$classes.asterisk',
            },
            children: [currentLocale === 'nl' ? ' - verplicht' : ' - required'],
          },
        ],
      }

      return schemaFn(sectionsSchema)
    }
  })
}

export default defineFormKitConfig({
  locale: 'nl',
  locales: { en, nl },
  // rules: {},
  // locales: {},
  // etc.
  plugins: [addAsteriskPlugin],
  theme: 'genesis',
  icons: {
    chevronDown: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
        <path fill="currentColor"
          d="M.4 5.7c.3-.3.7-.4 1.1-.4.4 0 .8.2 1.1.4l9.4 9.4 9.4-9.4c.1-.1.3-.3.5-.3s.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.4.2.5.3.1.1.3.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.3.5L13.1 18.3c-.3.3-.7.4-1.1.4-.4 0-.8-.2-1.1-.4L.4 7.8c-.2-.3-.4-.6-.4-1s.2-.8.4-1.1z"
        />
      </svg>
    `,
  },
})
